<template>
  <div class="wlx-apply-table-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <!-- <p class="p-title-1">“1+X”物流管理职业技能等级</p> -->
            <p class="p-title-1">考试报名申请表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-table-content">
      <h3 class="h3-text-center">{{examTile}}</h3>
      <el-table :data="siteList" style="width: 95%;margin: 0 auto;">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="SchoolName" label="单位名称"></el-table-column>
        <el-table-column prop="StudentNumber" label="考试人数"></el-table-column>
        <el-table-column prop="ExamDate" label="考试时间"></el-table-column>
        <el-table-column prop="ExamLevel" label="考试等级">
          <template slot-scope="scope">
            <span>{{ExamLevelList[scope.row.ExamLevel-1].value}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
              <el-button icon="el-icon-edit" size="mini" type="primary" @click="goEdit(scope.row)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
              <el-button
                icon="el-icon-delete"
                size="mini"
                type="danger"
                @click="godelete(scope.row.id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="submit-apply-btn">
        <el-button type="primary" @click="goback">返回</el-button>
        <el-button type="primary" @click="goadd()">添加考试</el-button>
      </div>
      <div
        style="margin-left: 20px;line-height: 20px;font-size: 20px;font-weight: 500;margin-bottom: 20px;"
      >考试时间说明：</div>
      <table border="0" cellspacing="0" cellpadding="0" class="wlx-table-exam" v-show="false">
        <tr>
          <td class="u-label-title" colspan="1">统考</td>
          <td class="u-label-title" colspan="3">考试时间安排</td>
          <td class="u-label-title" colspan="1">考试内容</td>
          <td class="u-label-title" colspan="1">考试级别</td>
        </tr>
        <tr class="u-label-title">
          <td colspan="1" rowspan="7">第一次统考</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="3">11月16日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">中级</td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="3">11月17日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">中级</td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>

        <tr class="u-label-title">
          <td colspan="1" rowspan="7">第二次统考</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="3">11月21日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">
            初级
            <br />中级
          </td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="3">11月22日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">
            初级
            <br />中级
          </td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>

        <tr class="u-label-title">
          <td colspan="1" rowspan="7">第三次统考</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="3">11月30日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">
            初级
            <br />中级
          </td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>

        <tr>
          <td colspan="1" rowspan="3">12月1日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">
            初级
            <br />中级
          </td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>

        <tr class="u-label-title">
          <td colspan="1" rowspan="7">第四次统考</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="3">12月7日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">
            初级
            <br />中级
            <br />高级
          </td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>

        <tr>
          <td colspan="1" rowspan="3">12月8日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">
            初级
            <br />中级
            <br />高级
          </td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>

        <tr class="u-label-title">
          <td colspan="1" rowspan="7">第五次统考</td>
        </tr>
        <tr>
          <td colspan="1" rowspan="3">12月21日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">
            初级
            <br />中级
            <br />高级
          </td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>

        <tr>
          <td colspan="1" rowspan="3">12月22日</td>
          <td colspan="1" rowspan="2">上午</td>
          <td colspan="1">08:30-10:00</td>
          <td colspan="1">基础考核</td>
          <td colspan="1" rowspan="3">
            初级
            <br />中级
            <br />高级
          </td>
        </tr>
        <tr>
          <td colspan="1">10:30-11:30</td>
          <td colspan="1">综合应用考核</td>
        </tr>
        <tr>
          <td colspan="1">下午</td>
          <td colspan="1">14:00-18:00</td>
          <td colspan="1">实操考核</td>
        </tr>

      </table>
      <div>
        <img :src="examTimeUrl" width="1000"/>
      </div>
      <div
        style="color:red;margin-left: 20px;line-height: 45px;font-size: 16px;font-weight: 500;margin-bottom: 20px;"
      >注：1.考试申报网址：www.clppx.org.cn（凭考核站点管理员账号登录）；
      <br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.高级无实操考核。</div>
    </div>
    <el-dialog :title="titleName" :visible.sync="dialogTableVisible" width="70%">
      <table border="0" cellspacing="0" cellpadding="0" style="width:650px;" class="wlx-table-exam">
        <tr>
          <td colspan="1" class="u-label-title">申报学校</td>
          <td colspan="3">{{schoolName}}</td>
        </tr>
        <tr>
          <td colspan="1" class="u-label-title">学校地址</td>
          <td colspan="3">
            <!-- <el-input v-model="linkAdderss"></el-input> -->
            <div class="td-select-citys">
              <span>省份:</span>
              <el-select v-model="provincePid" clearable placeholder="省份" @change="provinceChange">
                <el-option
                  v-for="item in provinceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="td-select-citys">
              <span>城市:</span>
              <el-select v-model="cityPid" clearable placeholder="城市" @change="cityChange">
                <el-option
                  v-for="item in cityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="td-select-citys">
              <span>县/区:</span>
              <el-select v-model="areaPid" clearable placeholder="县/区">
                <el-option
                  v-for="item in areaList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </td>
        </tr>

        <tr>
          <!-- <td colspan="1" class="u-label-title">报名账号</td>
          <td colspan="1">{{bmName}}</td> -->
          <td colspan="1" class="u-label-title">考务账号</td>
          <td colspan="3">{{kdName}}</td>
        </tr>
        <tr>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>考试人数</td>
          <td colspan="1">
            <!-- <el-input v-model="enrolmentCount"></el-input> -->
            <el-input-number
              v-model="enrolmentCount"
              controls-position="right"
              @change="handleChange"
              size="small"
              :min="0"
            ></el-input-number>
          </td>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>考试级别</td>
          <td colspan="1">
            <el-select v-model="examLevel" clearable placeholder="请选择考试等级" @change="getDateList">
              <el-option
                v-for="item in ExamLevelList"
                :key="item.value"
                :label="item.value"
                :value="item.lable"
              ></el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>考试时间</td>
          <td colspan="3">
            <el-select v-model="ExamDateId" clearable placeholder="请选择考试时间">
              <el-option
                v-for="item in ExamDateList"
                :key="item.StartTime"
                :label="item.StartTime"
                :value="item.Id"
                :disabled="!item.disabled"
              ></el-option>
            </el-select>
          </td>
        </tr>

        <tr>
          <td colspan="1" class="u-label-title"></td>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>姓名</td>
          <td colspan="2" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>手机号</td>
        </tr>
        <tr>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>总负责人</td>
          <td colspan="1">
            <el-input v-model="zname"></el-input>
          </td>
          <td colspan="2">
            <el-input v-model="zphone"></el-input>
          </td>
        </tr>
        <!-- <tr>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>实训场地管理员</td>
          <td colspan="1">
            <el-input v-model="sname"></el-input>
          </td>
          <td colspan="2">
            <el-input v-model="sphone"></el-input>
          </td>
        </tr> -->
        <tr>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>考务管理员</td>
          <td colspan="1">
            <el-input v-model="kname"></el-input>
          </td>
          <td colspan="2">
            <el-input v-model="kphone"></el-input>
          </td>
        </tr>
        <!-- <tr>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>报名管理员</td>
          <td colspan="1">
            <el-input v-model="bname"></el-input>
          </td>
          <td colspan="2">
            <el-input v-model="bphone"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>机房管理员</td>
          <td colspan="1">
            <el-input v-model="jname"></el-input>
          </td>
          <td colspan="2">
            <el-input v-model="jphone"></el-input>
          </td>
        </tr> -->

        <tr>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>手持型号及数量</td>
          <td colspan="3">
            <el-input v-model="handheldModel"></el-input>
          </td>
        </tr>
        
        <tr>
          <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>实操考场数</td>
          <td colspan="3">
            <!-- <el-input v-model="siteNum"></el-input> -->
             <el-input-number v-model="siteNum" :min="0"></el-input-number>
              个
          </td>
        </tr>

      </table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exit">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" width="650px">
      <div class="success-center">
        <div class="top-img">
          <img :src="dialogImg" alt="">
          <i @click="dialogVisible=false" class="el-dialog__close el-icon el-icon-close sp-icon-cha"></i>
        </div>
        <div class="text-content">
          <h3 class="h3-title-text">考试申报成功</h3>
          <!-- <p class="p-account-numbe">
            <span class="sp-text-hader">报名管理员账号：<span class="sp-number-info">{{bmName}}</span></span> 
            <span class="sp-text-hader">密码为：<span class="sp-number-info">{{bPassword}}</span></span>
          </p> -->
          <p class="p-account-numbe">
            <span class="sp-text-hader">考务管理员账号：<span class="sp-number-info">{{kdName}}</span></span> 
            <span class="sp-text-hader">密码为：<span class="sp-number-info">{{kPassword}}</span></span>
          </p>
          <div class="text-notice">
            <p>1、请妥善保存考务管理员帐号和密码；帐号一般为申报学校的名称+考务两字拼音首字母缩写，密码为考务管理员手机号。</p>
            <p>2、考务管理员账号可登陆考务系统 http://kw.clppx.org.cn 进行实操考题下载，上传考试情况记录表等操作。</p>
            <p>3、如若考务管理员帐号、密码丢失，请及时联系相关工作人员。</p>
          </div>
        </div>
      </div>
      <div class="btn-bottom" @click="dialogVisible=false">我知道了</div>
    </el-dialog>

  </div>
</template>

<script>
import avatarUpload from "components/avatarUpload.vue";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogTableVisible: false,
      titleName: "",
      //1、 中职 2、高职 3、本科
      ExamLevelList: [
        {
          lable: 1,
          value: "初级"
        },
        {
          lable: 2,
          value: "中级"
        },
        {
          lable: 3,
          value: "高级"
        }
      ],
      siteNum:0,
      ExamDateList: [],
      examLevel: "",
      radio: "",
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      dialogImg: require("assets/images/top-bg2.png"),
      enrolmentCount: 0,
      zname: "",
      zphone: "",
      sname: "",
      sphone: "",
      kname: "",
      kphone: "",
      bname: "",
      bphone: "",
      jname: "",
      jphone: "",
      examDate: "",
      ExamDateId:"",
      handheldModel: "",
      schoolName: "",
      bmName: "",
      kdName: "",
      name: "",
      page: 1,
      pageSize: 10,
      totalCount: 0,
      siteList: [],
      id: "",
      provincePid: "", //省
      cityPid: "",
      areaPid: "",
      provinceList: [], //省
      cityList: [], //市
      areaList: [], //区
      bPassword: "",
      kPassword: "",
      examTile:"",  // 考试标题
      examTimeUrl:""  // 考试时间安排
    };
  },
  components: {},
  created() {
    this.getSurplusNumber();
    this.getExamSchoolList();
    this.getProvinceList();
    this.getFileUrlList();
  },
  props: {
    certificateId:{
      type:String,
      default:""
    }
  },
  methods: {
    // IsNull(value){
    //   if(value == "" || value == null){
    //     this.$message.warning(
    //       "请先选择考试等级"
    //     );
    //   }
    // },
    getFileUrlList() {
      var that = this;
      this.$http
        .post("/api/XOrg/FileManager/getFileUrlList",{
          certificateId:this.certificateId
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.examTile = rst.list.ExamTitle;
            that.examTimeUrl = rst.list.ExamTimeUrl;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
     getProvinceList() {
      this.$http.post("/api/XOrg/District/getProvinceList").then(res => {
        if (res.code > 0) {
          this.provinceList = res.province;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    getCityList() {
      this.$http
        .post("/api/XOrg/District/getCityList", {
          province: this.provincePid
        })
        .then(res => {
          if (res.code > 0) {
            this.cityList = res.cityList;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
    },
    getCountyList() {
      this.$http
        .post("/api/XOrg/District/getCountyList", {
          city: this.cityPid
        })
        .then(res => {
          if (res.code > 0) {
            this.areaList = res.countylist;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
    },
     provinceChange() {
      this.cityPid = "";
      this.areaPid = "";
      this.getCityList();
    },
    cityChange() {
      this.areaPid = "";
      this.getCountyList();
    },

    handleChange(value) {
      if (value > 100) {
        this.$message.warning(
          "您报考的学生超过100人，为保证考试顺利进行，请确保机房有足够的学生机、至少两个标准实操考场"
        );
      }
    },
    getDateList() {
      // this.examDate ="";
      var that = this;
      this.$http
        .post("/api/XOrg/ExamSingUpManager/getDate", {
          examLevel: this.examLevel,
          certificateId:this.certificateId
        })
        .then(rst => {
          if (rst.code > 0) {
            // this.examDate = "";
            that.ExamDateList = rst.dateList;
            var i = 0;
            rst.dateList.forEach(element => {
              if(that.ExamDateId == element.Id){
                i = 1;
                that.ExamDateId = element.Id;
              }
            });
            if(i == 0){
              that.ExamDateId = "";
            }
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    goEdit(row) {
      this.dialogTableVisible = true; 
      this.titleName = "修改考试";
      this.enrolmentCount = row.StudentNumber;
      this.ExamDateId =  row.ExamDateId;
      // this.ExamDateId = row.ExamDateId;
      this.examLevel = row.ExamLevel;
      this.zname = row.ExamMainName;
      this.zphone = row.ExamMainPhone;
      this.sname = row.ExamPlaceName;
      this.sphone = row.ExamPlacePhone;
      this.kname = row.ExaminationName;
      this.kphone = row.ExaminationPhone;
      this.bname = row.SchoolSingUpName;
      this.bphone = row.SchoolSingUpPhone;
      this.jname = row.ExamRoomMangerName;
      this.jphone = row.ExamRoomMangerPhone;
      this.handheldModel = row.PDAType;
      this.siteNum = row.SiteNum;
      this.provincePid = row.ProvincePid;
      this.getCityList();
      this.cityPid = row.CityPid;
      this.getCountyList();
      this.areaPid = row.AreaPid;
      this.id = row.id;
      this.getDateList();
    },
    godelete(id) {
      var that = this;
      this.$confirm("此操作将删除该考试申报信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post("/api/XOrg/ExamSingUpManager/deleteExamSchool", {
              ids: id,
              SchoolName: this.schoolName,
            })
            .then(rst => {
              if (rst.code > 0) {
                that.$message.success(rst.msg);
                this.getExamSchoolList();
              } else {
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    exit() {
      this.clear();
      this.dialogTableVisible = false;
    },
    clear() {
      this.zname = "";
      this.zphone = "";
      this.sname = "";
      this.sphone = "";
      this.kname = "";
      this.kphone = "";
      this.bname = "";
      this.bphone = "";
      this.jname = "";
      this.jphone = "";
      this.provincePid = "";
      this.cityPid = "";
      this.areaPid = "";
      this.examLevel = "";
      this.ExamDateId = "";
      this.handheldModel = "";
      this.siteNum  =0;
      this.enrolmentCount = 0;
      this.id = "";
    },

    goadd() {
      this.dialogTableVisible = true;
      this.titleName = "添加考试";
    },
    goback() {
      this.$router.push({
        name: "teaApply"
      });
    },

    getExamSchoolList() {
      var that = this;
      this.$http
        .post("/api/XOrg/ExamSingUpManager/getExamSchoolList", {
          title: that.name,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(rst => {
          that.siteList = rst.list;
          that.page = rst.pagination.pageIndex;
          that.pageSize = rst.pagination.pageSize;
          that.totalCount = rst.pagination.totalCount;
        });
    },
    getSurplusNumber() {
      var that = this;
      this.$http
        .post("/api/XOrg/ExamSingUpManager/getSurplusNumber", {})
        .then(function(rst) {
          if (rst.code > 0) {
            // that.firstCount = rst.countOne;
            // that.secondCount = rst.countTow;
            // that.thirdCount = rst.countThree;
            // that.fourthCount = rst.countFour;
            that.kdName = rst.kdName;
            that.bmName = rst.bmName;
            // that.ExamDateList = rst.dateList;
            that.schoolName = rst.schoolName;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },

    submit() {
      debugger;
      const reg = /^1\d{10}$/;
      var that = this;
      if(this.provincePid == ""){
         this.$message.warning("请选择学校省份");
        return false;
      }
      if(this.cityPid == ""){
         this.$message.warning("请选择学校城市");
        return false;
      }
      if(this.areaPid == ""){
         this.$message.warning("请选择学校县/区");
        return false;
      }
      // if (this.enrolmentCount < 30) {
      //   this.$message.warning("报考人数不能少于30人");
      //   return false;
      // }
      if (this.examLevel == "" || this.examLevel == null) {
        this.$message.warning("请选择考试级别");
        return false;
      }
      if (this.ExamDateId == "" || this.ExamDateId == null) {
        this.$message.warning("请选择考试时间");
        return false;
      }
      if (this.zname == "") {
        this.$message.warning("请输入总负责人姓名");
        return false;
      }
      if (this.zphone == "") {
        this.$message.warning("请输入总负责人联系方式");
        return false;
      } else if (!reg.test(this.zphone)) {
        this.$message.warning("总负责人手机号格式不正确");
        return false;
      }
      // if (this.sname == "") {
      //   this.$message.warning("请输入实训场地管理员姓名");
      //   return false;
      // }
      // if (this.sphone == "") {
      //   this.$message.warning("请输入实训场地管理员联系方式");
      //   return false;
      // } else if (!reg.test(this.sphone)) {
      //   this.$message.warning("实训场地管理员手机号格式不正确");
      //   return false;
      // }
      if (this.kname == "") {
        this.$message.warning("请输入考务管理员姓名");
        return false;
      }
      if (this.kphone == "") {
        this.$message.warning("请输入考务管理员联系方式");
        return false;
      } else if (!reg.test(this.kphone)) {
        this.$message.warning("考务管理员手机号格式不正确");
        return false;
      }
      // if (this.bname == "") {
      //   this.$message.warning("请输入报名管理员姓名");
      //   return false;
      // }
      // if (this.bphone == "") {
      //   this.$message.warning("请输入报名管理员联系方式");
      //   return false;
      // } else if (!reg.test(this.bphone)) {
      //   this.$message.warning("报名管理员手机号格式不正确");
      //   return false;
      // }
      // if (this.jname == "") {
      //   this.$message.warning("请输入机房管理员姓名");
      //   return false;
      // }
      // if (this.jphone == "") {
      //   this.$message.warning("请输入机房管理员联系方式");
      //   return false;
      // } else if (!reg.test(this.jphone)) {
      //   this.$message.warning("机房管理员手机号格式不正确");
      //   return false;
      // }
      if (this.handheldModel == "") {
        this.$message.warning("请输入手持型号及数量");
        return false;
      }
      if(this.siteNum == null){
        this.$message.warning("实操考场数不能为空");
        return false;
      }
      this.$http
        .post("/api/XOrg/ExamSingUpManager/addOrEditInfo", {
          id: this.id,
          StudentNumber: this.enrolmentCount,
          SchoolName: this.schoolName,
          BmName: this.bmName,
          KdName: this.kdName,
          ExamLevel: this.examLevel,
          ExamDate: this.ExamDateId,
          ExamMainPhone: this.zphone,
          ExamMainName: this.zname,
          ExamPlacePhone: this.sphone,
          ExamPlaceName: this.sname,
          ExaminationPhone: this.kphone,
          ExaminationName: this.kname,
          SchoolSingUpPhone: this.bphone,
          SchoolSingUpName: this.bname,
          ExamRoomMangerPhone: this.jphone,
          ExamRoomMangerName: this.jname,
          PDAType: this.handheldModel,
          SiteNum:this.siteNum,
          ProvincePid :this.provincePid,
          CityPid:this.cityPid,
          AreaPid:this.areaPid,
          certificateId:this.certificateId
        })
        .then(function(rst) {
          if (rst.code > 0) {
            // const h = that.$createElement;
            // that.$message({
            //   message: h("div", null, [
            //     h("p", null, [
            //       h("span", { style: "color: #000" }, "保存成功"),
            //     ]),
            //     h("p", null, [
            //       h("span", { style: "color: #000" }, "报名管理员账号为："),
            //       h("span", { style: "color: red" }, that.bmName),
            //        h("span", { style: "color: #000" }, "  密码为报名管理员手机号："),
            //       h("span", { style: "color: red" }, that.bphone),
            //       // h("span", { style: "color: #000" }, "登录")
            //     ]),
            //     h("p", null, [
            //       h("span", { style: "color: #000" },  "考务管理员账号为："),
            //       h("span", { style: "color: red" },that.kdName),
            //       h("span", { style: "color: #000" },  "  密码为考务管理员手机号："),
            //       h("span", { style: "color: red" }, that.kphone),
            //     ])
            //   ]),
            //   type: "success",
            //   duration: 60000,
            //   showClose: true,
            // });
            // that.$message.success(rst.msg);
            that.bPassword = that.bphone;
            // that.kPassword = that.kphone;

            that.kPassword = rst.kwPhone;
            that.dialogVisible = true;
            that.dialogTableVisible = false;
            that.getExamSchoolList();
            that.clear();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-apply-table-wrapper {
  height: 100%;
  overflow: auto;
  background: #f0f6ff;
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .basic-book-img-con {
      margin-left: 10px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 55px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
  }
  .apply-table-content {
    margin: -325px auto 0;
    padding: 20px 0;
    padding-top: 10px;
    width: 1000px;
    background: #fff;
  }
  .h3-text-center {
    text-align: center;
    font-size: 25px;
    line-height: 60px;
  }
  .p-down-applyTable-btn {
    text-align: right;
    color: #0365f5;
    padding: 0 22px 20px 0;
    cursor: pointer;
    font-size: 17px;
  }
  .apply-table-title {
    padding: 20px 0;
    text-align: center;
  }
  .submit-apply-btn {
    padding: 20px 0;
    text-align: center;
  }
  .label-job-con {
    padding: 0 20px;
  }
  .wlx-table-exam {
    margin: 0 auto;
    width: 960px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    table-layout: fixed;
    word-break: break-all;
    background: #f0f0f0;
    td {
      border-left: 1px solid #999;
      border-top: 1px solid #999;
      text-align: center;
    }
    td {
      height: 41px;
      font-size: 16px;
    }
  }
  table {
  }
  .u-label-title {
    font-weight: bold;
  }
  .demo-table {
    margin-top: 100px;
  }
  .expert-certify-ul {
    height: 100%;
  }
  .expert-certify-li {
    width: 25%;
  }
  .certify-li-cell {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
  }
  .certify-li-cell-num {
    border-top: none;
  }
  .fistCertify {
    .certify-li-cell {
      border-left: none;
    }
  }
  .el-textarea__inner,
  .el-input__inner {
    border: none;
    font-size: 16px;
    color: #000;
  }
  .input-edu .el-input__inner {
    height: 82px;
    line-height: 82px;
  }
  .el-textarea__inner:focus {
    border: none;
  }
  .el-input__inner:focus {
    border: none;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
  .label-opinion-title {
    padding: 10px;
    text-align: left;
  }
  .sp-mark-label {
    color: red;
  }
  .h4-major-title {
    padding: 10px 0;
  }
  .success-center{
    position: relative;
    .top-img{
      position: absolute;
      top: -60px;
      left: -20px;
      border-radius: 10px 10px 0 0;
    }
    img{
      border-radius: 10px 10px 0 0;
    }
    .sp-icon-cha{
      position: absolute;
      font-size: 25px;
      top: 17px;
      right: 15px;
      color: #fff;
      cursor: pointer;
    }
    .text-content{
      padding-top: 110px;
      .h3-title-text{
        width: 100%;
        color: #409EFF;
        font-size: 20px;
        text-align: center;
        margin-bottom: 30px;
      }
      .p-account-numbe{
        .sp-text-hader{
          margin-right: 40px;
          display: inline-block;
        }
        span{
          color: #333333;
          font-size: 16px;
        }
        .sp-number-info{
          color: #F32B55;
          font-weight: bold;
        }
      }
      .text-notice{
        margin-top: 26px;
        border: 1px solid #CCCCCC;
        padding: 14px;
        color: #DC0935;
        line-height: 22px;
      }
    }
  }
  .btn-bottom{
    width:120px;
    height:40px;
    background:rgba(56,160,255,1);
    border-radius:4px;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    margin: 18px auto 0;
    cursor: pointer;
  }
  .el-dialog{
    border-radius: 10px;
  }
}
  .el-message__closeBtn{
    top:20%;
    color: #000;
    font-size: 20px;
  }
  .td-select-citys {
    width: 33.333%;
    display: inline-block;
    .el-select {
      width: 65%;
    }
  }
</style>
